import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CreatableSelect from '../_shared/forms/FormCreatableSelect';
import SubmitButton from '../_shared/SubmitButton';
import UserService from '../../services/UserService';

class Operatives extends Component {
    constructor(props) {
        super(props);

        this.userService = new UserService();

        const mapToSelectOption = (o) => ({
            ...o,
            label: o.name.toUpperCase(),
            value: o.id,
        });

        this.state = {
            operatives: (props.operatives || []).map(mapToSelectOption),
            selected: (props.user.assigned_operatives || []).map(mapToSelectOption),
            loading: false,
            errors: {},
        };
    }

    handleChange = (value) => {
        this.setState({ selected: value || [] });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        const operativeIds = this.state.selected.map(o => o.id);

        this.userService
            .storeOperatives(this.props.user.id, operativeIds)
            .then(() => {
                this.setState({ loading: false });
                toastr.success('Operatives assigned successfully');
            })
            .catch(() => {
                this.setState({ loading: false });
                toastr.error('Failed to assign operatives');
            });
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <h6 className="py-2 pl-2 cw-bg-grey text-white">
                    Assign Operatives
                </h6>

                <CreatableSelect
                    isMulti
                    options={this.state.operatives}
                    prefixes={this.state.selected}
                    handleMultiSelectChange={this.handleChange}
                />

                <SubmitButton
                    buttonText="Save operatives"
                    loading={this.state.loading}
                    style={{ width: 230, marginTop: 30 }}
                />
            </form>
        );
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const element = document.getElementById('user-operatives');
    if (element) {
        const operatives = JSON.parse(element.dataset.operatives || '[]');
        const user = JSON.parse(element.dataset.user || '{}');

        ReactDOM.render(
            <Operatives operatives={operatives} user={user} />,
            element
        );
    }
});

export default Operatives;